<app-call-pathway-roleplay *ngIf="callFlow() === 'role-play'"
  [controlService]="controlService"
  [realtimeService]="realtimeService"
  [userVideoService]="userVideoService"
  [deviceSettingsService]="deviceSettingsService"
  [playerService]="playerService"
  [callStore]="callStore"
  [enrollmentStepUuid]="enrollmentStepUuid"
  [enrollmentUuid]="enrollmentUuid"
  [stepType]="stepType"
  [callUuid]="rolePlayCallUuid()"
  [callType]="rolePlayCallType()"
  [runStepResponse]="runStepResponse"
  (settingsClicked)="handleSettingsClick()"
  (leaveStepClicked)="handleLeaveStepClick()"
  (confirmActionClicked)="handleOnConfirmActionClick()"
  [title]="title()"
></app-call-pathway-roleplay>

<app-device-settings-call
  *ngIf="showDeviceSettingsScreen()"
  [deviceSettingsService]="deviceSettingsService"
  [controlService]="controlService"
  [playerService]="playerService"
></app-device-settings-call>

<ng-container *ngIf="callFlow() !== 'role-play'">

  <!-- Call Header -->
  <app-pathway-call-header
    *ngIf="!showDeviceSettingsScreen()"
    [isLoading]="isLoading()"
    [title]="title()"
    (settingsClicked)="handleSettingsClick()"
    (leaveStepClicked)="handleLeaveStepClick()"
  >
  </app-pathway-call-header>

  <!-- Call Main Content -->
  <app-pathway-call-main
    *ngIf="!showDeviceSettingsScreen()"
    [isLoading]="mainIsLoading()"
    [isPdf]="callFlow() === 'pdf'"
  >
    @switch (callFlow()) { @case ('guide') {
    <app-call-pathway-guide
      [controlService]="controlService"
      [realtimeService]="realtimeService"
      [callStore]="callStore"
      [playerService]="playerService"
      [deviceSettingsService]="deviceSettingsService"
      [hideUserVideo]="isPreamble() && stepType !== 'QUIZ'"
    />
    } @case ('pdf') {
    <app-call-pathway-pdf
      [pdfUrl]="pdfViewerUrl()"
      [enrollmentUuid]="enrollmentUuid"
      [initialPage]="initialPdfPage()"
      [isFirstAttempt]="isFirstAttempt()"
      (progressChange)="onPdfProgressChange($event)"
      (pdfCompleted)="handlePdfCompleted()"
      [callLearnUuid]="callLearnUuid()"
    />
    } @case ('video') {
    <app-call-pathway-video
      [src]="videoSrc()"
      [firstAttempt]="isFirstAttempt()"
      [startTime]="videoStartTimeMs() / 1000"
      [enrollmentUuid]="enrollmentUuid"
      [callLearnUuid]="callLearnUuid()"
      (videoReady)="onVideoReady($event)"
      (videoPlay)="onVideoPlay()"
      (videoEnded)="handleVideoEnded()"
      (videoTimeUpdate)="onVideoTimeUpdate($event)"
      (videoPause)="onVideoPause()"
    />}
    @case ('error') {
    <app-call-pathway-error />
    } @case ('quiz-result') {
    <app-quiz-result
      [callStore]="callStore"
      [outcome]="quizOutcome()"
      [ttsReady]="quizResultTtsReady()"
      [stepsToReview]="quizStepsToReview()"
      (subtitleTextChange)="onQuizResultSubtitle($event)"
      (ttsPlayingChange)="onQuizResultTtsPlaying($event)"
      (avatarThumbnailReady)="onQuizResultAvatarThumbnail($event)"
    />
    } }
  </app-pathway-call-main>

  <!-- Call Footer -->
  <app-pathway-call-footer
    *ngIf="!showDeviceSettingsScreen() && stepType && !isStepTypePracticeCall"
    [captionText]="captionText()"
    [subtitleKind]="subtitle().kind"
    [subtitleText]="subtitle().text"
    [avatarPhotoUrl]="avatarPhotoUrl()"
    [showAvatarPhoto]="showAvatarPhoto()"
    [showSubtitles]="callFlow() !== 'quiz-result' || !quizResultTtsDone()"
  >
    <app-pathway-call-controls
      [isMicOn]="callStore?.getIsMicOn() ?? false"
      [disableMicButton]="disableMicButton"
      (microphoneClicked)="handleMicrophoneClick()"
      [isVideoOn]="controlService?.isVideoOn ?? false"
      [isCameraAvailable]="getCameraAvailable()"
      [disableVideoButton]="disableVideoButton"
      [disableConfirmActionButton]="
        disableConfirmActionButton() || mainIsLoading()
      "
      [confirmActionLabel]="getConfirmActionLabel()"
      (videoClicked)="handleVideoClick()"
      (onConfirmActionClicked)="handleOnConfirmActionClick()"
      [showMicrophoneButton]="shouldShowMicControl()"
      [showCameraButton]="shouldShowVideoControl()"
    />
  </app-pathway-call-footer>

  <!-- Leave step early modal -->
  <app-call-leave-early
    [open]="leaveStepModalOpen()"
    [controlService]="controlService"
    [realtimeService]="realtimeService"
    [description]="leaveStepModalDescription()"
    (confirmLeave)="handleLeaveStepConfirm()"
    (resume)="handleLeaveStepResume()"
  ></app-call-leave-early>

</ng-container>

<!-- Settings modal -->
<app-device-settings-modal
  *ngIf="deviceSettingsService?.displayModal"
  [deviceSettingsService]="deviceSettingsService"
  [controlService]="controlService"
></app-device-settings-modal>
